// extracted by mini-css-extract-plugin
module.exports = {"recentDocumentsContainer":"RecentDocuments_recentDocumentsContainer__2OZZR","recentDocumentsTitle":"RecentDocuments_recentDocumentsTitle__1cuo-"};